export default "__VITE_ASSET__7b5d5eca__"